// @flow
import { normalize } from 'normalizr'
import typeToReducer from 'type-to-reducer'

import { isValidTTL, calculateExpires } from '@alphaott/app-main/selectors'
import categoriesListSchema from '@alphaott/common-utils/utils/schemas/categories'

import type { Language } from '@alphaott/api-client/types/languages'

import { FETCH_RADIO_CHANNEL_LANGUAGES } from '../../actions/radioChannelLanguages'

export type RadioChannelLanguagesState = {
  +isLoading: boolean,
  +isSuccess: boolean,
  +isError: boolean,
  +errors: any,
  +data: Array<Language>,
  +result: Array<string>,
  +expires: ?number,
}

const initialState: RadioChannelLanguagesState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  errors: [],
  data: [],
  result: [],
  expires: null,
}

const radioChannelLanguages = typeToReducer(
  {
    [FETCH_RADIO_CHANNEL_LANGUAGES]: {
      LOADING: (state): RadioChannelLanguagesState => ({ ...state, isLoading: true }),

      SUCCESS: (state, action): RadioChannelLanguagesState => {
        const {
          meta: { ttl },
        } = action
        const { result } = normalize(action.payload.data, categoriesListSchema)
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          data: action.payload.data,
          result,
          ...(isValidTTL(ttl) && { expires: calculateExpires(ttl) }),
        }
      },

      ERROR: (state, action): RadioChannelLanguagesState => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        errors: action.payload.error,
        expires: null,
      }),
    },
  },
  initialState,
)

export { radioChannelLanguages }
